import { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';

export default function EmailVerificationPage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'verifying' | 'success' | 'error'>('verifying');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    
    if (!token) {
      setStatus('error');
      setMessage('No verification token provided.');
      return;
    }

    // Call API to verify email
    axios.get(`/api/verify-email?token=${token}`)
      .then(response => {
        setStatus('success');
        setMessage(response.data.message);
      })
      .catch(error => {
        setStatus('error');
        setMessage(error.response?.data?.message || 'Verification failed. Please try again.');
      });
  }, [searchParams]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className="card" style={{ maxWidth: '500px', width: '90%', textAlign: 'center' }}>
        {status === 'verifying' && (
          <>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>⏳</div>
            <h1>Verifying Your Email...</h1>
            <p style={{ color: 'var(--gray-600)' }}>Please wait while we verify your email address.</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{ fontSize: '3rem', marginBottom: '1rem', color: '#10b981' }}>✓</div>
            <h1 style={{ color: '#10b981' }}>Email Verified!</h1>
            <p style={{ color: 'var(--gray-600)', marginBottom: '2rem' }}>{message}</p>
            <Link to="/dashboard" className="btn btn-primary">
              Go to Dashboard
            </Link>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{ fontSize: '3rem', marginBottom: '1rem', color: '#ef4444' }}>✗</div>
            <h1 style={{ color: '#ef4444' }}>Verification Failed</h1>
            <p style={{ color: 'var(--gray-600)', marginBottom: '2rem' }}>{message}</p>
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
              <Link to="/dashboard" className="btn btn-secondary">
                Go to Dashboard
              </Link>
              <Link to="/login" className="btn btn-primary">
                Login
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
